export default __webpack_public_path__ + "static/media/emoji_fear.011e83e0.png";